import React from "react"
import { RouteObject } from "react-router-dom"
import TenantPage from "../page/payment.page"
import AuthGuard from "../../../shared/auth/component/auth"
import PaymentPage from "../page/payment.page"
export const PaymentRoute: RouteObject = {
  path: "/payment",
  element: (
    <AuthGuard role={["super_admin", "owner", "tenant"]} permission={["manage-payments", "view-payments"]}>
      <PaymentPage />
    </AuthGuard>
  ),
}
